import React from 'react';
import { VerificationSummary } from '../../../../../services/insurance/types/verification-summary';
import { PatientIvFlowProps } from '../../types/patient-iv-flow-props';
import { PatientIvStatusDialogProvider } from './provider';

export interface PatientIvStatusDialogHocProps {
  opened: boolean;
  locationId: number;
  providerId: number | undefined;
  selectedIvSummary?: VerificationSummary;
  patientFlow: PatientIvFlowProps;
  appointment?: {
    isEnded?: boolean;
  };
  onClose: () => void;
}

export const withPatientIvStatusDialogProvider = <P extends PatientIvStatusDialogHocProps>(
  Component: React.ComponentType<P>
) => {
  const ComponentWidthProvider: React.FC<P> = (props) => {
    const { opened, onClose, locationId, patientFlow, providerId, selectedIvSummary, appointment } = props;

    return (
      <>
        {opened && (
          <PatientIvStatusDialogProvider
            opened={opened}
            onClose={onClose}
            locationId={locationId}
            patientFlow={patientFlow}
            providerId={providerId}
            selectedIvSummary={selectedIvSummary}
            appointment={appointment}
          >
            <Component {...props} />
          </PatientIvStatusDialogProvider>
        )}
      </>
    );
  };

  return ComponentWidthProvider;
};
